import React, { Suspense, useEffect, useState } from 'react';
import { ROUTE_HOME, ROUTE_AUTH_ACCOUNT_TYPE } from 'constants/routes';
import { useManagement } from 'context/managementContext';
import { useFeatureFlag } from 'context/featureFlagContext';
import { useSubscription } from 'context/subscriptionContext';
import { useNavigate } from 'react-router-dom';
import { UnsavedChangesProvider } from 'context/unsavedChangesContext';
import PrivateRoute from 'routes/components/PrivateRoute';
import PublicRoute from 'routes/components/PublicRoute';

const Loader = () => <div>Loading...</div>;

const LayoutRoute = ({ protection, component: Component, interfaceType = null, requiresSubscription = false, ...rest }) => {
	const navigate = useNavigate();
	const { user, isLoading: isManagementLoading, hasSelected, hasAgreed } = useManagement();
	const { subscriptionEnabled, subscriptionTokenEnabled, termsAgreementEnabled } = useFeatureFlag();
	const { hasSubscription, loading: subscriptionLoading, tokenPromise } = useSubscription();

	const [holdOn, setHoldOn] = useState(subscriptionTokenEnabled);

	if (subscriptionEnabled && requiresSubscription && !hasSubscription && !subscriptionLoading) {
		navigate(ROUTE_HOME);
	}

	useEffect(() => {
		if (!hasSelected() && !isManagementLoading) navigate(ROUTE_AUTH_ACCOUNT_TYPE);

		if (termsAgreementEnabled && !hasAgreed()) navigate(ROUTE_AUTH_ACCOUNT_TYPE);
	}, [user]);

	useEffect(() => {
		if (!subscriptionTokenEnabled) return;

		setHoldOn(true);

		const waitSubscriptionToken = async () => {
			if (tokenPromise) {
				tokenPromise.then((token) => {
					setHoldOn(false);
				});
			}
		};

		waitSubscriptionToken();
	}, [tokenPromise, hasSubscription]);

	const Structure = <Suspense fallback={<Loader />}>{holdOn ? <></> : <Component />}</Suspense>;

	const getInterfaceType = () => {
		if (interfaceType) return interfaceType;

		return user ? user.currentManagement.toLocaleLowerCase() : '';
	};

	return (
		<UnsavedChangesProvider>
			{protection ? <PrivateRoute {...rest} interfaceType={getInterfaceType()} component={Structure} /> : <PublicRoute {...rest} component={Structure} />}
		</UnsavedChangesProvider>
	);
};

export default LayoutRoute;
